import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);
export default {
    data() {
        return {
            title: '',
            bannerImg: [],
            link: '',
            showDate: '',
            showStartDate: '',
            showEndDate: '',
        }
    },
    validators: {
        title: function (value) {
            return Validator.value(value)
                .required('제목을 입력해주세요.')
        },
        bannerImg: function (value) {
            return Validator.value(value)
        },
        link: function (value) {
            return Validator.value(value)
                .required('이동링크를 입력해주세요.')
        },
        showDate: function (value) {
            return Validator.value(value)
        },
        showStartDate: function (value) {
            return Validator.value(value)
        },
        showEndDate: function (value) {
            return Validator.value(value)
        },
    },
    methods: {},
    computed: {},
}